import React from 'react';
import { Layout } from 'antd';

export default function Blank(props) {
  const { children } = props;
  return (
    <Layout.Content className="noPadding" style={{ height: '100vh' }}>
      {children}
    </Layout.Content>
  );
}
